export default "__VITE_ASSET__B6iLstLj__"